import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="container my-5 text-center">
      <div className="row">
        <div className="col-md-8 mx-auto">
          <div className="mb-4">
            <i className="bi bi-exclamation-triangle" style={{ fontSize: '5rem', color: '#0D4D26' }}></i>
          </div>
          <h1 className="display-1 fw-bold">404</h1>
          <h2 className="mb-4">Page Not Found</h2>
          <p className="lead mb-5">
            We're sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          <div className="d-flex justify-content-center gap-3">
            <Link to="/" className="btn btn-primary">
              Back to Home
            </Link>
            <Link to="/contact" className="btn btn-outline-primary">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 